import useAuth from '@contexts/AuthProvider';
import { Link, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export default function LoginLink() {
  const { login } = useAuth();
  const { t, i18n } = useTranslation();

  return (
    <Stack sx={{ direction: 'row', spacing: 1, width: '100%', justifyContent: 'start' }}>
      <Typography>
        <Trans i18nKey="registration.alreadyAnAccount" />
      </Typography>
      <Link
        component="button"
        onClick={() => void login({ locale: i18n.resolvedLanguage })}
        sx={{ fontWeight: 900 }}
        aria-label={t('accessibility.login')}
        data-test-id="button-login"
      >
        <Trans i18nKey="registration.actions.login" />
      </Link>
    </Stack>
  );
}
